module.exports = __webpack_public_path__ + "static/media/icon-minus.f9d19804.svg";